import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IServiceResponseData, IServiceState } from "../@types/service";
import { IApiResponse } from "../@types/api-response";

const initialState: IServiceState = {
  services: [],
  service: null,
  current_page: 1,
  last_page: 1,
  limit: 20,
  offset: 0,
  total: 0,
  loading: false,
};

export const service = createSlice({
  name: "service",
  initialState,
  reducers: {
    setServices: (
      state,
      action: PayloadAction<IApiResponse<IServiceResponseData>>,
    ) => {
      state.services = action.payload.data.data;
      state.limit = Math.max(1, action.payload.data.limit);
      state.offset = action.payload.data.offset;
      state.total = action.payload.data.total;
      state.current_page = Math.floor(state.offset / state.limit) + 1;
      state.last_page = Math.max(1, Math.ceil(state.total / state.limit));
    },
    setService: (state, action) => {
      state.service = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    onBack: (state) => {
      if (state.current_page > 1) {
        state.current_page -= 1;
        state.offset = Math.max(0, state.offset - state.limit);
      }
    },
    onNext: (state) => {
      if (state.current_page < state.last_page) {
        state.current_page += 1;
        state.offset += state.limit;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setServices, setService, setLoading, onBack, onNext } =
  service.actions;

export default service.reducer;
